import PrivateLayout from '@/layouts/PrivateLayout.vue';
import DevicesList from '@/pages/devices/DevicesList.vue';
import DevicesPlaces from '@/pages/devices/DevicesPlaces.vue';
import ClosedDays from '@/pages/devices/ClosedDays.vue';
import InsertedCoins from '@/pages/devices/InsertedCoins.vue';
import ClearedDays from '@/pages/devices/ClearedDays.vue';
import DevicesMessages from '@/pages/devices/DevicesMessages.vue';

export default [
  {
    path: '/devices',
    component: PrivateLayout,
    meta: { requiresAuth: true, roles: ['superuser', 'user'] },
    children: [
      {
        path: 'list',
        name: 'DevicesList',
        component: DevicesList,
      },
      {
        path: 'places',
        name: 'DevicesPlaces',
        component: DevicesPlaces,
      },
      {
        path: 'closed-days',
        name: 'ClosedDays',
        component: ClosedDays,
      },
      {
        path: 'inserted-coins',
        name: 'InsertedCoins',
        component: InsertedCoins,
      },
      {
        path: 'cleared-days',
        name: 'ClearedDays',
        component: ClearedDays,
      },
      {
        path: 'messages',
        name: 'DevicesMessages',
        component: DevicesMessages,
      },
    ],
  },
];
